var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wizard-body small-9 columns"},[(_vm.isEmbedded)?_c('whatsapp-embedded-signup'):(_vm.isManual)?_c('cloud-whatsapp',{attrs:{"show-back":""}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }